<button [ngClass]="styling.wrapper()" [disabled]="status === 'disabled'">
    <span>{{ label }}</span>

    <svg *ngIf="content.icon()" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" class="icon">
        <path
            d="M256-192.35 192.35-256l224-224-224-224L256-767.65l224 224 224-224L767.65-704l-224 224 224 224L704-192.35l-224-224-224 224Z"
        />
    </svg>
</button>
